<template>
  <div class="molecules-carousel-partner">
    <swiper-container
      ref="swiper"
      class="mb-8"
      slides-per-view="5"
      space-between="24"
    >
      <swiper-slide
        v-for="(company, companyIndex) in companies"
        :key="companyIndex"
      >
        <atoms-card class="text-center inline-flex items-center justify-center h-40 w-full">
          <AtomsImage
            :src="company.image"
            :alt="company.title"
            height="56"
            width="auto"
            class="max-w-full"
          />
        </atoms-card>
      </swiper-slide>
    </swiper-container>

    <p>
      These logos represent some of the brands that we compare, we do not compare all products in the market and that we are not recommending any of the brands displayed: you will need to talk to a financial advisor to identify the best product that suits your needs.
    </p>
  </div>
</template>

<script setup>
import { register } from 'swiper/element/bundle'
register()

const {
  sourceCompanies
} = useEnv()

defineOptions({
  name: 'MoleculesCarouselPartner'
})

const props = defineProps({
  vertical: {
    type: String,
    default: 'Health Insurance'
  }
})

const companies = await (async () => {
  const response = await useAsyncData(() => $fetch(sourceCompanies))
  const tempVertical = strToSnakeCase(props.vertical)

  if (response?.status.value !== 'success') {
    return []
  }

  return response.data.value[tempVertical]
})()

const swiper = ref()

onMounted(() => {
  const el = swiper.value

  Object.assign(el, {
    slidesPerView: 1,
    breakpoints: {
      320: {
        slidesPerView: 2
      },
      640: {
        slidesPerView: 4
      },
      1024: {
        slidesPerView: 5
      }
    }
  })
  el.initialize()
})
</script>

<style lang="scss" scoped>
swiper-container::part(container) {
  padding: 2.5rem 1.25rem;
  margin: -2.5rem -1.25rem;
}
</style>
